import create from 'zustand';
import { persist } from 'zustand/middleware';

import { StorageE } from 'declarations/enums/storage';

type LocationT = {
  pathName: string;
  search: string;
};

type UseLocationStoreT = {
  location: LocationT;
  setLocation: (location: LocationT) => void;
};

const useLocationStore = create<UseLocationStoreT>()(
  persist(
    (set): UseLocationStoreT => ({
      location: {
        pathName: '',
        search: '',
      },
      setLocation: (location): void => set({ location }),
    }),
    {
      name: StorageE.LocationStore,
      getStorage: (): Storage => localStorage,
    }
  )
);

export default useLocationStore;
